query SuggestionAlbums {
  suggestionAlbums {
    id
    name
  }
}
